import React from "react";

import { screenshotUrl } from "../../api/agent";
import { useAuthImage } from "../../hooks/useAuthImage";

export default function MessageImage({ imagePath, imageUrl, token }) {
  const { src } = useAuthImage(imageUrl || screenshotUrl(imagePath), token);
  if (!src) return null;
  return (
    <a href={src} target="_blank" rel="noopener noreferrer">
      <img src={src} alt="capture" className="mt-2 max-h-48 max-w-full rounded border" />
    </a>
  );
}
